/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { GeometryLabelDto } from './GeometryLabelDto';
import {
    instanceOfGeometryLabelDto,
    GeometryLabelDtoFromJSON,
    GeometryLabelDtoFromJSONTyped,
    GeometryLabelDtoToJSON,
} from './GeometryLabelDto';

/**
 * @type DiscreteNumericValueDtoGeometry
 * 
 * @export
 */
export type DiscreteNumericValueDtoGeometry = GeometryLabelDto;


export function DiscreteNumericValueDtoGeometryFromJSON(json: any): DiscreteNumericValueDtoGeometry {
    return DiscreteNumericValueDtoGeometryFromJSONTyped(json, false);
}

export function DiscreteNumericValueDtoGeometryFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscreteNumericValueDtoGeometry {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...GeometryLabelDtoFromJSONTyped(json, true) };
    return  GeometryLabelDtoFromJSONTyped(json, true);
}

export function DiscreteNumericValueDtoGeometryToJSON(value?: DiscreteNumericValueDtoGeometry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfGeometryLabelDto(value)) {
        return GeometryLabelDtoToJSON(value as GeometryLabelDto);
    }

    return {};
}

/**
 * Check if a given object implements the DiscreteNumericValueDtoGeometry interface.
 */
export function instanceOfDiscreteNumericValueDtoGeometry(value: any): value is DiscreteNumericValueDtoGeometry {
    if (instanceOfGeometryLabelDto(value)) return true;
    return false;
}

